import React, { useContext, useRef, useEffect } from "react";
import { SearchContext } from "../App";
import { useNavigate, useLocation } from "react-router-dom";
import providerSearchIcon from "../assets/Icons/provider-search-bar-ic.svg";
import {
  fetchProviderSearchSuggestions,
  fetchPracticeSearchSuggestions,
} from "../store/Searchlist/SearchListAction";
import { useDispatch } from "react-redux";

const SearchHeaders = () => {
  const navigateTo = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const {
    searchPracticeParams,
    searchProviderParams,
  } = useContext(SearchContext);

  const searchSubmit = (event) => {
    event.preventDefault();
  };

  useEffect(() => {
    inputRef.current.focus();
  }, []);

  const inputRef = useRef(null);

  useEffect(() => {
    dispatch(fetchProviderSearchSuggestions(searchProviderParams));
    dispatch(fetchPracticeSearchSuggestions(searchPracticeParams));
  }, [searchPracticeParams, searchProviderParams]);

  //handle keypress for search box
  const handleKeyPress = (event) => {
    const searchText = event.target.value.trim();
    if (event.key === "Enter" && searchText !== "") {
      if (location.pathname == "/dashboard") {
        navigateTo("/dashboard/providers?search=" + searchText);
      } else if (location.pathname == "/dashboard/providers") {
        navigateTo("/dashboard/providers?search=" + searchText);
      } else if (location.pathname == "/dashboard/practices") {
        navigateTo("/dashboard/practices?search=" + searchText);
      } else if (location.pathname) {
        navigateTo("/dashboard/providers?search=" + searchText);
      }
      // Select all text after Enter
      event.target.select();
      // inputRef.current.value = "";
    }
    return false;
  };

  return (
    <form
      className="search-form pull-left"
      name="searchForm"
      onSubmit={searchSubmit}
    >
      <input
        id="searchTop"
        placeholder="Search"
        type="search"
        ref={inputRef}
        onKeyDown={handleKeyPress}
      />
      <button type="submit" className="flush-padding">
        <img src={providerSearchIcon} alt="" />
      </button>
    </form>
  );
};

export default SearchHeaders;
